import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "holder absolute z-40 text-white" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "school font-bold" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "blackShade absolute top-0 z-30 left-0 w-full h-full" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "yellowShade absolute top-0 z-20 left-0 w-full h-full" }, null, -1)
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.boxClicked && _ctx.boxClicked(...args))),
    class: _normalizeClass(["contentBox relative", _ctx.screen == 'phone' && 'mt-3']),
    style: _normalizeStyle({ width: _ctx.boxWidth })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.info.school)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", {
              style: _normalizeStyle(_ctx.titleSize),
              class: "title font-bold"
            }, _toDisplayString(_ctx.info.school), 5),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.info.title), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", {
              style: _normalizeStyle(_ctx.titleSize),
              class: "title font-bold",
              innerHTML: _ctx.info.title
            }, null, 12, _hoisted_5),
            _createElementVNode("p", {
              class: "company font-bold",
              innerHTML: _ctx.info.company
            }, null, 8, _hoisted_6)
          ]))
    ]),
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("img", {
      class: _normalizeClass([_ctx.fit, "object-cover z-10"]),
      src: _ctx.info.image
    }, null, 10, _hoisted_9)
  ], 6))
}